import { praseToken, createScheduleTask, parseNumber } from "@/utils/utils"
import { getIsOnline } from "@/api/auth"
import { setTenantId } from "@/plugins/env"

/**
 * 定时刷新Token
 */
const handleRefreshToken = ({ $cookies }) => {
  const refreshTime = parseNumber(process.env.VUE_APP_REFRESH_TOKEN_TIME, 1000 * 60 * 5)
  const scheduleTask = createScheduleTask({
    callback: async () => {
      const token = $cookies.get("token")
      const parseData = token ? praseToken(token) : null
      if (token) {
        try {
          await getIsOnline({
            token,
            yuuId: parseData?.loyaltyCardId || parseData?.LoyaltyCardId
          })
        } catch (error) {
          console.log(error)
        }
      } else {
        scheduleTask.stop()
      }
    },
    interval: refreshTime,
    immediate: true
  })

  scheduleTask.start()
}
/**
 * 客户端初始化
 * @param {*} context
 */

export default function (context) {
  setTenantId(context)
  handleRefreshToken(context)
}
